<template>
    <v-autocomplete v-model="form.hour" v-bind="{ ...$attrs, items }" @input="emit" />
</template>

<script>
const initForm = (form = {}) => ({
    ...(form || {}),

    hour: form?.hour ?? 10,
    minute: form?.minute ?? 0,
});
export default {
    props: {
        value: { type: Object, default: initForm },
    },
    data: () => ({
        form: initForm(),

        items: new Array(24).fill("").map((_, index) => ({
            text: `${12 <= index ? "오후" : "오전"} ${(index % 12 || 12).toString().padStart(2, "0")}시`,
            value: index,
        })),
    }),
    methods: {
        sync() {
            this.form = initForm(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style>
</style>